import 'whatwg-fetch'; // fetch polyfill

import './index.scss';
import { run } from './run.jsx';

run();



// WEBPACK FOOTER //
// ./src/client/app/index.jsx